import styled from 'styled-components'
import { Link as GatsbyLink } from 'gatsby'
import React from 'react'

export const ProjectHeader = styled.div`
  background: ${(props) => props.theme.global.bg};
  color: ${(props) => props.theme.global.color};
  padding: 0.5em;
  border-radius: 0.3em 0.3em 0 0;
`
export const ProjectCardContainer = styled.div`
  background: rgb(${(props) => props.theme.global.bg});
  margin: 1rem 0;
  display: flex;
  flex: 1 1 auto;
  max-width: 500px;
  flex-direction: column;
  border-radius: 0.3em;
`

export const DescriptionContainer = styled.div`
  p: first-child {
    margin: 0.5em 0;
    font-weight: bold;
  }
`

export const ProjectInformation = styled.div`
  p {
    margin: 0.1em 0;
  }
  div:nth-child(n + 1) {
    padding: 0.5em;
  }
`

export const ProjectMenuContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  text-transform: uppercase;
  font-size: 0.9rem;
  min-height: 2em;
  max-width: 100%;
  align-items: center;
  .active {
    text-decoration: underline;
    text-underline-offset: 5px;
  }
  button {
    color: rgb(${(props) => props.theme.global.color});
  }
`

export const ProjectMenuButton = styled.span`
  display: flex;
  align-items: center;
`

export const ReadMoreButton = styled.span`
  color: darkOrange;
  cursor: pointer;
`

export const ProjectLink = styled((props) => <GatsbyLink {...props} />)`
  padding: 0.9em 0.5em;
    color: rgb(${(props) => props.theme.global.link});
    margin: 0em;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    gap: 10px;
`
